import { render, staticRenderFns } from "./HyphenData.vue?vue&type=template&id=6caa5eb2&scoped=true"
import script from "./HyphenData.vue?vue&type=script&setup=true&lang=js"
export * from "./HyphenData.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HyphenData.vue?vue&type=style&index=0&id=6caa5eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caa5eb2",
  null
  
)

export default component.exports